module.exports = "<div class=\"<%= header %>\">\r\n    <div class=\"<%= header__back %>\" ng-click=\"onBack()\">\r\n        <span class=\"fa fa-arrow-left\"></span>\r\n    </div>\r\n    <div class=\"<%= header__title %>\">\r\n        <ng-transclude></ng-transclude>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/pagestructure/mobileheader/MobileHeader.html
// module id = 953
// module chunks = 0